import React, { lazy } from 'react';
import PrivateRoute from 'PrivateRoutes';
import { withRouter } from 'react-router-dom';
const AdminDashboard = lazy(()=> import(/* webpackChunkName: "AdminDashboard" */'./components'));

const routes = () => [
  <PrivateRoute
    key='admin-dashboard'
    exact
    path='/admin-dashboard'
    component={AdminDashboard}
  />,
];

export default withRouter(routes);



// WEBPACK FOOTER //
// src/modules/screens/AdminDashboard/routes.js